/**
 * Matching Instruction for the order.
 * tag: 1625
 * @readonly
 * @enum {number} (int)
 */
export enum MatchInst {
  /** Match */
  Match = 1,
  /** Do Not Match */
  DoNotMatch = 2,
}
